import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import atoms from './Atoms';
import Api from './Api';

export default () => {
    const { getEvents } = Api();
    const [ events, setEvents ] = useRecoilState(atoms.events);

    useEffect(() => {
        if (events.length === 0) {
            getEvents().then(e => setEvents(
                e.map(e => ({ ...e, date: new Date(e.date)})).sort((a, b) => b.date - a.date)
            ));
        }
    }, []);

    return {
        getAllEvents: () => events,
        setAllEvents: setEvents,
        getEvents: () => ({
            pastEvents: events.filter(e => e.date <= new Date()),
            futureEvents: events.filter(e => e.date > new Date()),
        }),
        getCarouselEvents: () => events
            .filter(e => e.type === 'Build-a-Bot Session')
            .slice(0, 5)
            .map(e => ({ ...e, type: e.date > new Date() ? 'future' : 'past' })),
    }
};
